// TeamPage.jsx
import  { useState, useEffect } from "react";
import {
  Button,
  Container,
  Grid,
  TextField,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
} from "@mui/material";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import DeleteIcon from "@mui/icons-material/Delete";
import { Post_To_MongoDB_No_Alert } from "../../api/Post_To_MongoDB_No_Alert";
import { Get_All_From_MongoDB } from "../../api/Get_All_From_MongoDB";
import { Push_To_MongoDB_EntreDayFour_No_Alert } from "../../api/Push_To_MongoDB_EntreDayFour_No_Alert";
import { Delete_DayFourEntr_MongoDB_No_Alert } from "../../api/Delete_DayFourEntr_MongoDB_No_Alert";

// Simulated in-memory DB
let mockTeamDB = [

];

export default function EntrDayFour() {
  const [email, setEmail] = useState(localStorage.getItem("InvestINEntrDayFourEmail") || "");
  const [emailSubmitted, setEmailSubmitted] = useState(false);
  const [linkSubmittedStatus, setLinkSubmittedStatus] = useState(false);


  const [team, setTeam] = useState("");
  const [link, setLink] = useState("");
  const [teams, setTeams] = useState([
  { team: "Alpha", link: "https://alpha.com", UpVoters: [], DownVoters: [] },
  { team: "Beta", link: "https://beta.com", UpVoters: [], DownVoters: [] },
]);

  // Load data every 10s
  useEffect(() => {
    const loadData = () => {
            Get_All_From_MongoDB("Test", "EntreDayFour", setTeams);
    };
    loadData();
    const interval = setInterval(loadData, 10000);
    return () => clearInterval(interval);
  }, []);

  const handleEmailSubmit = () => {
    if (email.trim()) {
      setEmailSubmitted(true);
       localStorage.setItem("InvestINEntrDayFourEmail", email.trim());
    }
  };

  function isAlreadyVoted(Email, team) {
    if (!team) return false;
    return (team.UpVoters && 
        Array.isArray(team.UpVoters) && team.UpVoters.includes(Email)) || 
        (team.DownVoters && Array.isArray(team.DownVoters) && team.DownVoters.includes(Email));
  }

  const handleUpload = () => {
    if (!team || !link) return;
    const newTeam = {
      team,
      link,
      UpVoters: [],        
      DownVoters: [],
      whoMade: email,
    };
    mockTeamDB = [...teams];
    mockTeamDB.push(newTeam);
    setTeam("");
    setLink("");
    setTeams([...mockTeamDB].sort((a, b) => b.UpVoters.length - a.UpVoters.length));
    Post_To_MongoDB_No_Alert(
        newTeam,
        "Test",
        "EntreDayFour",
        setLinkSubmittedStatus
      );
      console.log(linkSubmittedStatus)
  };
 


const handleVote = (teamId, type) => {
  let TeamObject = teams.find((team) => team._id === teamId);

  if (isAlreadyVoted(email, TeamObject)) {
    return;
  } else {
    mockTeamDB = teams.map((team) => {
      if (team._id === teamId) {
        return {
          ...team,
          UpVoters: type === "up" ? [...team.UpVoters, email] : team.UpVoters,
          DownVoters: type === "down" ? [...team.DownVoters, email] : team.DownVoters,
        };
      }
      return team;
    });
    setTeams([...mockTeamDB].sort((a, b) => b.UpVoters.length - a.UpVoters.length));
        Push_To_MongoDB_EntreDayFour_No_Alert(
      email,
      TeamObject.link,
      type === "up" ? "UpVoters" : "DownVoters"
    )
  }
};

function handleDelete(teamId) {
    Delete_DayFourEntr_MongoDB_No_Alert(teamId);
}

let sortedTeams = [...teams].sort((a, b) => {
      const aUpvotes = (a.UpVoters && Array.isArray(a.UpVoters)) ? a.UpVoters.length : 0;
      const bUpvotes = (b.UpVoters && Array.isArray(b.UpVoters)) ? b.UpVoters.length : 0;
      return bUpvotes - aUpvotes > 0 ? 1 : -1;
    });


  if (!emailSubmitted) {
    return (
      <Container maxWidth="sm" sx={{ mt: 10 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h5" gutterBottom>
            Enter Your Email
          </Typography>
          <TextField
            fullWidth
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={localStorage.getItem("InvestINEntrDayFourEmail") ? true : false}
          />
          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
            onClick={handleEmailSubmit}
          >
            Continue
          </Button>
        </Paper>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Crowd Funding Submission Page
      </Typography>

      {/* Form */}
      <Paper sx={{ p: 3, mb: 4 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={5}>
            <TextField
              label="Team Name"
              fullWidth
              value={team}
              onChange={(e) => setTeam(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={5}>
            <TextField
              label="Team Link"
              fullWidth
              value={link}
              onChange={(e) => setLink(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              sx={{ height: "100%" }}
              onClick={handleUpload}
            >
              Upload
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {/* Table */}
      <Paper sx={{ p: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Team Name</TableCell>
              <TableCell>Link</TableCell>
              <TableCell align="center">Upvotes</TableCell>
              <TableCell align="center">Downvotes</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedTeams.map((row) => (
              <TableRow key={row._id}>
                <TableCell>{row.team}</TableCell>
                <TableCell>
                  <a href={row.link} target="_blank" rel="noreferrer">
                    {row.link}
                  </a>
                </TableCell>
                <TableCell align="center">{row.UpVoters && row.UpVoters.length ? row.UpVoters.length : 0}</TableCell>
                <TableCell align="center">{row.DownVoters && row.DownVoters.length ? row.DownVoters.length : 0}</TableCell>
                <TableCell align="center">
                  <IconButton
                    color="success"
                    onClick={() => handleVote(row._id, "up")}
                    disabled={isAlreadyVoted(email, row) ? true : false}
                  >
                    <ThumbUpIcon />
                  </IconButton>
                  <IconButton
                    color="error"
                    onClick={() => handleVote(row._id, "down")}
                    disabled={isAlreadyVoted(email, row) ? true : false}
                  >
                    <ThumbDownIcon />
                  </IconButton>
                </TableCell>
                {localStorage.getItem("Username") === "harold@investin.org" ? 
                <TableCell align="center">
                  <DeleteIcon
                    color="error"
                    onClick={() => handleDelete(row._id)}
                  >
                    <ThumbDownIcon />
                  </DeleteIcon>
                </TableCell> : null}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Container>
  );
}
